import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Sourcing from "./pages/Sourcing";
import Production from "./pages/Production";
import Sustainability from "./pages/Sustainability";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import ReportReader from "./pages/ReportReader";
import JobApply from "./pages/JobApply";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from './components/ScrollToTop';

// Admin
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import Login from "./admin/Login";
import Dashboard from "./admin/Dashboard";
import ReportsAdmin from "./admin/ReportsAdmin";
import JobsAdmin from "./admin/JobsAdmin";
import ApplicationsAdmin from "./admin/ApplicationsAdmin";
import CatalogueAdmin from "./admin/CatalogueAdmin";
import ContactAdmin from "./admin/ContactAdmin";

// The public-facing site: shared nav + footer around the page routes.
const PublicSite = () => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navigation />
    <main style={{ flex: 1, paddingTop: "80px" }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/sourcing" element={<Sourcing />} />
        <Route path="/production" element={<Production />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/apply/:jobId" element={<JobApply />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/report/:id" element={<ReportReader />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

const App = () => {
  useEffect(() => {
    // Hide loader when React app is fully loaded
    const loader = document.getElementById('loader');
    if (loader) {
      setTimeout(() => {
        loader.classList.add('fade-out');
        setTimeout(() => {
          loader.style.display = 'none';
        }, 500);
      }, 2000); // Start hiding after 2 seconds from component mount
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Admin — no public nav/footer, not linked from the site */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="reports" element={<ReportsAdmin />} />
              <Route path="jobs" element={<JobsAdmin />} />
              <Route path="applications" element={<ApplicationsAdmin />} />
              <Route path="catalogue" element={<CatalogueAdmin />} />
              <Route path="contact" element={<ContactAdmin />} />
            </Route>

            {/* Everything else is the public site */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
